import { item } from './item';
import { tabs } from './tabs';

/**
 * @param {Object} airport Airport object
 * @param {Object[]} kallebakomOffers available offers
 * @returns HTML String
 */

export const body = (airport, kallebakomOffers) => {
	if (!kallebakomOffers.length) {
		console.warn('No Kallebakom offers available');
		return;
	}

	const manyOptionsExist = kallebakomOffers.length > 1;


	return `
    <div class="kallebakom_content">
      ${manyOptionsExist
      ? `<div class="abTabNav--changeKalle">
              ${tabs(kallebakomOffers)}
           </div>`
      : ''}
      <div class="kallebakom__items">
        ${kallebakomOffers.map(k => item(k, airport.airport)).join('')}
      </div>
    </div>
  `;
};
